import * as Yup from 'yup';
import dayjs from 'dayjs';

import { UuidableName } from 'utils/api/types';

import { PickerValue } from 'components/SharedFormComponents/UserAndGroupPicker';

export interface AcknowledgementRequestFormValues {
  name: string;
  document: UuidableName | null;
  recipients: PickerValue[];
  dueDate: string | null;
}

export const initialValues: AcknowledgementRequestFormValues = {
  name: '',
  document: null,
  recipients: [],
  dueDate: null,
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required').max(256, 'Name must be 256 characters or fewer'),
  document: Yup.object().nullable().required('Document is required'),
  recipients: Yup.array().min(1, 'Select at least one recipient or group'),
  dueDate: Yup.string()
    .nullable()
    .required('Due date is required')
    .test('not-in-past', 'Due date must be today or later', (value) => {
      if (!value) return false;
      const date = dayjs(value);
      if (!date.isValid()) return false;
      return date.startOf('day').isSame(dayjs().startOf('day')) || date.isAfter(dayjs().startOf('day'));
    }),
});
